(() => {
  const shellSelector = '[data-uk-product2024-shell]';
  const zoomButtonSelector = `${shellSelector} .product__photo-zoom`;
  const state = {
    items: [],
    index: 0,
    modal: null,
  };

  const getGalleryItems = (shell) => {
    return [...shell.querySelectorAll('.product-main-slide')]
      .map((slide) => {
        const image = slide.querySelector('img.photoswipe__image');
        if (!image) return null;

        return {
          src: image.dataset.photoswipeSrc || image.currentSrc || image.src,
          alt: image.alt || '',
        };
      })
      .filter(Boolean);
  };

  const getModal = () => {
    if (state.modal) return state.modal;

    const modal = document.createElement('div');
    modal.className = 'uk-product2026-zoom-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Product image zoom');
    modal.innerHTML = `
      <div class="uk-product2026-zoom-modal__backdrop" data-uk-zoom-close></div>
      <div class="uk-product2026-zoom-modal__dialog">
        <button type="button" class="uk-product2026-zoom-modal__close" data-uk-zoom-close aria-label="Close image zoom">&times;</button>
        <button type="button" class="uk-product2026-zoom-modal__previous" data-uk-zoom-previous aria-label="Previous product image">&#8249;</button>
        <img class="uk-product2026-zoom-modal__image" alt="">
        <button type="button" class="uk-product2026-zoom-modal__next" data-uk-zoom-next aria-label="Next product image">&#8250;</button>
        <div class="uk-product2026-zoom-modal__counter" aria-live="polite"></div>
      </div>
    `;

    modal.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('[data-uk-zoom-close]')) {
        closeModal();
      } else if (target.closest('[data-uk-zoom-previous]')) {
        showImage(state.index - 1);
      } else if (target.closest('[data-uk-zoom-next]')) {
        showImage(state.index + 1);
      }
    });

    document.body.appendChild(modal);
    state.modal = modal;
    return modal;
  };

  const showImage = (index) => {
    if (!state.items.length || !state.modal) return;

    state.index = (index + state.items.length) % state.items.length;
    const item = state.items[state.index];
    const image = state.modal.querySelector('.uk-product2026-zoom-modal__image');
    const counter = state.modal.querySelector('.uk-product2026-zoom-modal__counter');
    const previous = state.modal.querySelector('[data-uk-zoom-previous]');
    const next = state.modal.querySelector('[data-uk-zoom-next]');

    image.src = item.src;
    image.alt = item.alt;
    counter.textContent = `${state.index + 1} / ${state.items.length}`;
    previous.hidden = state.items.length < 2;
    next.hidden = state.items.length < 2;
  };

  const openModal = (button) => {
    const shell = button.closest(shellSelector);
    if (!shell) return;

    state.items = getGalleryItems(shell);
    if (!state.items.length) return;

    const slides = [...shell.querySelectorAll('.product-main-slide')];
    const currentSlide = button.closest('.product-main-slide');
    state.index = Math.max(0, slides.indexOf(currentSlide));

    const modal = getModal();
    showImage(state.index);
    modal.hidden = false;
    document.body.classList.add('uk-product2026-zoom-open');
    modal.querySelector('.uk-product2026-zoom-modal__close').focus();
  };

  const closeModal = () => {
    if (!state.modal) return;
    state.modal.hidden = true;
    document.body.classList.remove('uk-product2026-zoom-open');
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest(zoomButtonSelector);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openModal(button);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!state.modal || state.modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showImage(state.index - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      showImage(state.index + 1);
    }
  });
})();
